'use client'

import { forwardRef, HTMLAttributes, useContext, MouseEvent, FocusEvent } from 'react'
import clsx from 'classnames'
import { useFloatingTree } from '@floating-ui/react'
import { MenuContext } from './utils'
import styles from './dropdown-menu.module.scss'

interface MenuItemProps extends HTMLAttributes<HTMLLIElement> {
  disabled?: boolean
  isActive?: boolean
}

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, forwardedRef) => {
  const { className, disabled, children, ...restProps } = props
  const menu = useContext(MenuContext)
  const tree = useFloatingTree()

  return (
    <li
      {...restProps}
      ref={forwardedRef}
      role="menuitem"
      className={clsx(className, styles.menuItem, { [styles.disabled]: disabled })}
      tabIndex={-1}
      {...menu.getItemProps({
        onClick(event: MouseEvent<HTMLLIElement>) {
          props.onClick?.(event)
          tree?.events.emit('click')
        },
        onFocus(event: FocusEvent<HTMLLIElement>) {
          props.onFocus?.(event)
          menu.setHasFocusInside(true)
        },
      })}
    >
      {children}
    </li>
  )
})

MenuItem.displayName = 'MenuItem'
